<template>
  <div class="check-item">
    <div class="row">
      <div class="col-sm-7">{{ i18n.connectionSpeed }}</div>
      <div class="col-sm-3">
        <div class="result">{{ result.text }}</div>
      </div>
      <div class="col-sm-2">
        <checker-status :result="result.value"></checker-status>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <div class="alert alert-warning" v-show="result.value === 'warning'">{{ i18n.results.connectionSpeedBelowMedium }}</div>
        <div class="alert alert-danger" v-show="result.value === 'failed'">{{ i18n.results.connectionSpeedBelowMinimum }}</div>
      </div>
    </div>
  </div>
</template>

<script>
/* global Image */
import log from 'loglevel'
import CheckerStatus from './CheckerStatus'

const checkerName = 'connection-speed'

export default {
  name: checkerName,
  data () {
    return {
      status: 'in-progress',
      result: {
        value: '',
        text: ''
      },
      i18n: window.SYSTEM_CHECK.i18n
    }
  },
  components: {
    CheckerStatus
  },
  created () {
    this.$emit('initialized', {name: checkerName})
  },
  mounted () {
    if (!window.SYSTEM_CHECK.imageDownloadUrl) {
      log.error('No image download URL found')
      return
    }

    log.debug('Starting connection speed test')

    var startTime = new Date().getTime()
    var img = new Image()
    img.onload = () => {
      // The size of the image is 1741.802 KB, it should be converted to Kb;
      var size = 1741.802 * 8
      var duration = new Date().getTime() - startTime
      var speed = Math.round(size * 1000 / duration)
      this.result.text = speed + ' Kbps'

      if (speed < 384) {
        this.result.value = 'failed'
      } else if (speed >= 384 && speed <= 800) {
        this.result.value = 'warning'
      } else if (speed > 800) {
        this.result.value = 'passed'
      }
      this.$emit('completed', {name: checkerName, result: this.result.text})
    }
    img.onerror = () => {
      this.result.value = 'failed'
      this.result.text = 'Connection failed'
      this.$emit('completed', {name: checkerName, result: this.result.text})
    }
    img.src = window.SYSTEM_CHECK.imageDownloadUrl + '?_=' + startTime
  }
}

</script>



// WEBPACK FOOTER //
// ConnectionSpeed.vue?92453a02